module.exports = __webpack_public_path__ + "static/media/newscript.dbc92074.jpg";